import * as React from 'react'
import { useTranslations } from 'next-intl'
import type { Editor } from '@tiptap/react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'

interface YoutubeEditBlockProps {
  editor: Editor
  close: () => void
}

export const YoutubeEditBlock: React.FC<YoutubeEditBlockProps> = ({
  editor,
  close,
}) => {
  const t = useTranslations('tiptap')
  const fileInputRef = React.useRef<HTMLInputElement>(null)
  const [link, setLink] = React.useState('')

  const handleClick = React.useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  const handleFile = React.useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = e.target.files
      if (!files?.length) return

      const insertImages = async () => {
        const contentBucket = []
        const filesArray = Array.from(files)

        for (const file of filesArray) {
          contentBucket.push({ src: file })
        }

        editor.commands.setImages(contentBucket)
      }

      await insertImages()
      close()
    },
    [editor, close],
  )

  const handleSubmit = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      e.stopPropagation()

      if (!e.currentTarget.checkValidity()) {
        // 不合法，阻止提交
        return
      }

      if (link) {
        editor.commands.setYoutubeVideo({
          src: link,
        })
        close()
      }
    },
    [editor, link, close],
  )

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-1">
        <Label htmlFor="image-link">{t('add_youtube_link')}</Label>
        <div className="flex">
          <Input
            id="youtube-link"
            type="url"
            required
            placeholder="https://www.youtube.com/watch?v=VIDEO_ID"
            value={link}
            pattern="https:\/\/(www\.|m\.)?(youtube\.com|youtu\.be|youtube-nocookie\.com)(\/.*|\?.*)?.*"
            className="grow"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setLink(e.target.value)
            }
          />
          <Button type="submit" className="ml-2">
            {t('submit')}
          </Button>
        </div>
      </div>
    </form>
  )
}

export default YoutubeEditBlock
